(() => {
  const mql = window.matchMedia('(max-width: 989px)');
  const CLASS_HIDE = 'is-hidden';

  let observer = null;

  function getStickyEl() {
    return document.querySelector('.custom-mobile-price-actions');
  }

  function getTargetEl() {
    return document.querySelector('.what-in-box');
  }

  function setHidden(hidden) {
    const sticky = getStickyEl();
    if (!sticky) return;
    sticky.classList.toggle(CLASS_HIDE, !!hidden);
  }

  function start() {
    if (!mql.matches) return;
    const target = getTargetEl();
    if (!target) return;

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        const entry = entries && entries[0];
        setHidden(!!entry && entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  function stop() {
    if (observer) observer.disconnect();
    observer = null;
    setHidden(false);
  }

  mql.addEventListener('change', (e) => {
    if (e.matches) start();
    else stop();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

